module.exports = __webpack_public_path__ + "img/contract_top4.6d0d8437.png";